var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.appClass,attrs:{"id":"app"}},[(_vm.show)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }